import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Link, useNavigate } from "react-router-dom";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import ApiCall from "../../utils/Api";
import Web3 from "web3";
import axios from "axios";
import { toast } from "react-toastify";
import bigInt from "big-integer";
import Swal from "sweetalert2";
import contractABI from "../../utils/contractABI";
// import TDU from "../../utils/TDU"; // Removed - using ETH payments only
import EditIcon from '@mui/icons-material/Edit';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import {convertDateFormat,extractTimeFromTimestamp} from "../../utils/services";
import moment from 'moment-timezone';

export default function BuyFundAssestsTable({
  setBackDropState,
  BackDropState,
  data, // Add data prop to receive data from parent
  instrument,
  market,
  institutionName,
  date
}) {
  
  const contractAddress = import.meta.env.VITE_APP_contractAddress; // Main contract address
  // const TDUcontractAddress = import.meta.env.VITE_APP_TDUcontractAddress; // Removed - using ETH payments only
  
  const [isconnected, setisconnected] = useState(false);
  const [rows, setRows] = useState([]);
  const [web3, setWeb3] = useState(null);
  const [fxContract, setFxContract] = useState(null);
  // const [tduContract, setTduContract] = useState(null); // Removed - using ETH payments only
  const [updateCount, setupdateCount] = useState(0);
  const [UnitStatus, setUnitStatus] = useState("");
  let Navigate=useNavigate()
  const status=localStorage.getItem("status")
  const [ticketQuantities, setTicketQuantities] = useState({});
  const [selectedLevels, setSelectedLevels] = useState({}); // Track selected level for each row

  useEffect(() => {
    // Use data passed from parent component instead of making API call
    if (data && data.length > 0) {
      console.log("BuyFundAssestsTable received data:", data);
      console.log("First item pricingLevels:", data[0]?.pricingLevels);
      console.log("First item dataUnitId fields:", {
        dataunitId: data[0]?.dataunitId,
        _id: data[0]?._id,
        id: data[0]?.id
      });
      setRows(data);
    } else {
      setRows([]);
    }
  }, [data, updateCount]);

  

  const [showPopup, setShowPopup] = useState(false);
  const [results, setResults] = useState([]);
  const [item, setItem] = useState({});
  const [resultq, setResultq] = useState("");
  const [prov_address, setprov_Address] = useState("");
  const role=localStorage.getItem("role")

  // useEffect(() => {
  //   // console.log(props.contract, props.web3);

  //   getAllDataUnits();
  // }, []);

  // const axios = require('axios');








let name=localStorage.getItem('name');
  // Ensure wallet is connected and network is correct
  const ensureWalletAndNetwork = async () => {
    if (!window.ethereum) {
      throw new Error("MetaMask not found. Please install or enable it.");
    }
    // Prompt connection (opens MetaMask if not connected)
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    
    // Validate that the connected wallet is registered with the user's profile
    const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
    const registeredWallets = data.data.data || [];
    const connectedAccount = accounts[0].toLowerCase();
    const isRegisteredWallet = registeredWallets.some(wallet => 
      wallet.toLowerCase() === connectedAccount
    );
    
    if (!isRegisteredWallet) {
      throw new Error("Connect Wallet Address registered with this profile");
    }
    
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    const targetChainId = '0x' + parseInt(import.meta.env.VITE_APP_CHAIN_ID || '11155111').toString(16); // Convert to hex
    console.log('Current chain ID:', chainId, 'Target chain ID:', targetChainId);
    if (chainId !== targetChainId) {
      try {
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: targetChainId }],
        });
      } catch (switchError) {
        throw new Error("Please switch MetaMask to the correct network (Sepolia)");
      }
    }
    return accounts && accounts[0];
  };
  // ✅ FIXED: Updated to work with the actual smart contract function
  // Updated to use Sepolia ETH payments instead of TDU tokens
  async function buyDataUnit(dataUnit, walletId) {
    // Check for dataUnitId in multiple possible fields
    const dataUnitId = dataUnit?.dataunitId || dataUnit?._id || dataUnit?.id;
    if(!dataUnitId){
      console.error('Data Unit object:', dataUnit);
      console.error('Available fields:', Object.keys(dataUnit || {}));
      toast.error('Data Unit id is Empty');
      return
    }

    try {
      // Ensure MetaMask opens and user is connected to correct chain
      await ensureWalletAndNetwork();
      const buyerAddress = walletId; // This is the buyer's wallet address
      
      // Get the quantity for this data unit
      // Priority: 1) from row object (ticketsQuantity or quantity), 2) from state, 3) default to 1
      let quantity = dataUnit.ticketsQuantity || dataUnit.quantity || ticketQuantities[dataUnit._id] || 1;
      
      // Also check for level-specific quantity key if _id and levelIndex are available
      if (!dataUnit.ticketsQuantity && !dataUnit.quantity && dataUnit.levelIndex !== undefined) {
        const levelSpecificKey = `${dataUnit._id}_${dataUnit.levelIndex}`;
        quantity = ticketQuantities[levelSpecificKey] || quantity;
      }
      if (dataUnit.levelIndex !== undefined) {
        const levelSpecificKey = `${dataUnit._id}_${dataUnit.levelIndex}`;
        quantity = ticketQuantities[levelSpecificKey] || quantity;
      }
      
      // Ensure quantity is a number and valid
      quantity = parseInt(quantity) || 1;
      
      if (quantity <= 0) {
        toast.error('Please select at least 1 ticket');
        return;
      }
      
      // Calculate total price based on quantity
      const singleTicketPrice = dataUnit.price;
      if (!singleTicketPrice) {
        throw new Error("Ticket price unavailable for selected fund level");
      }
      const totalPrice = BigInt(singleTicketPrice) * BigInt(quantity);

      setBackDropState(true);

      if (!web3 || !fxContract) {
        throw new Error("Web3 or contract not initialized");
      }
      
      // Check if buyDataUnit function exists on FX contract
      if (!fxContract?.methods?.buyDataUnit) {
        throw new Error("buyDataUnit function not found on FX contract. Available methods: " + Object.keys(fxContract.methods).join(", "));
      }
      
      // VALIDATION: Ensure dataUnitId is a valid number
      let finalDataUnitId = dataUnitId;
      
      if (!finalDataUnitId) {
        throw new Error(`No valid dataUnitId found. Available fields: ${Object.keys(dataUnit).join(", ")}`);
      }
      
      if (typeof finalDataUnitId === 'string') {
        const parsedId = parseInt(finalDataUnitId);
        if (isNaN(parsedId)) {
          throw new Error(`Invalid dataUnitId: ${finalDataUnitId}. Must be a valid number.`);
        }
        finalDataUnitId = parsedId;
      }
      
      // Check ETH balance instead of TDU tokens
      const ethBalance = await web3.eth.getBalance(buyerAddress);
      const ethBalanceEth = web3.utils.fromWei(ethBalance, 'ether');
      const singlePriceEth = web3.utils.fromWei(singleTicketPrice, 'ether');
      const totalPriceEth = web3.utils.fromWei(totalPrice.toString(), 'ether');
      

      // Check if balance covers the total price (with some buffer for gas)
      if (BigInt(ethBalance) < totalPrice) {
        throw new Error(`Insufficient ETH balance. Required: ${totalPriceEth} ETH, Available: ${ethBalanceEth} ETH`);
      }

      const unitPriceEth = web3.utils.fromWei(singleTicketPrice.toString(), 'ether');

      console.log("🧾 Purchase payload:", {
        dataUnitId: finalDataUnitId,
        quantity,
        unitPriceWei: singleTicketPrice.toString(),
        totalPriceWei: totalPrice.toString(),
        unitPriceEth,
        totalPriceEth
      });

      // Try to estimate gas, but if it fails still attempt to send to open MetaMask
      try {
        await fxContract.methods.buyDataUnit(finalDataUnitId, quantity).estimateGas({ 
          from: buyerAddress,
          value: totalPrice.toString() 
        });
      } catch (gasError) {
        console.warn("Gas estimation failed, attempting to send anyway to prompt MetaMask:", gasError);
      }
      
      // Send ETH payment with the transaction
      const transaction = await fxContract.methods
        .buyDataUnit(finalDataUnitId, quantity)
        .send({
          from: buyerAddress,
          value: totalPrice.toString(), // Send total ETH as payment
        });
      setBackDropState(false);
      
      // Blockchain transaction successful
      if (transaction.transactionHash) {
        // Prepare purchase data - ensure selectedLevel is properly structured
        const selectedLevelFromState = selectedLevels[dataUnit._id];
        let selectedLevelToSend = null;
        
        // Handle selectedLevel structure - it might be the levelData object or the full structure
        if (selectedLevelFromState) {
          // If it's the stored structure with levelData, use levelData
          selectedLevelToSend = selectedLevelFromState.levelData || selectedLevelFromState;
        } else if (dataUnit.selectedLevel) {
          // If row has selectedLevel directly, use that
          selectedLevelToSend = dataUnit.selectedLevel;
        }
        
        // Ensure we're using MongoDB _id (string/ObjectId), not blockchain dataunitId (number)
        const mongoDataUnitId = dataUnit._id;
        if (!mongoDataUnitId) {
          console.error("❌ No MongoDB _id found in dataUnit:", dataUnit);
          toast.error("Error: Missing data unit ID. Please contact support.");
          return;
        }
        
        const purchaseData = {
          dataUnitId: mongoDataUnitId, // Use MongoDB _id, not blockchain dataunitId
          transactionHash: transaction.transactionHash,
          WalletAddress: buyerAddress,
          buyerName: name,
          pricingType: dataUnit.pricingType || 'fixed',
          selectedLevel: selectedLevelToSend,
          ticketsPurchased: quantity,
          priceWei: singleTicketPrice,
          totalWei: totalPrice.toString(),
          fundUnitName: dataUnit.fundUnitName,
          fundName: dataUnit.name,
          institutionName: dataUnit.providerData?.institutionName,
          institutionCode: dataUnit.providerData?.institutionCode
        };
        
        // Try to save to backend, but don't fail the whole purchase if this fails
        try {
          const data = await ApiCall.SECURE_API.post("/buyer/buyDataUnit", purchaseData);
          setupdateCount(updateCount+1);
          toast.success(data.data.message || "Purchase completed successfully!");
          
          // Trigger event to refresh FundInvestmentsTable
          window.dispatchEvent(new CustomEvent('purchaseCompleted', { 
            detail: { 
              fundName: dataUnit.name,
              ticketsPurchased: quantity,
              transactionHash: transaction.transactionHash
            } 
          }));
          
          // Also update localStorage to trigger storage event (for cross-tab sync)
          localStorage.setItem('fundPurchaseUpdate', Date.now().toString());
        } catch (apiError) {
          // Backend save failed, but blockchain transaction succeeded
          console.error("⚠️ Backend save failed, but purchase was successful:", apiError);
          
          // Show success message for blockchain transaction
          toast.success(`Purchase completed successfully! Transaction Hash: ${transaction.transactionHash.substring(0, 10)}...`);
          
          // Show warning about backend save failure
          toast.warning(
            "Purchase recorded on blockchain, but there was an issue saving to database. " +
            "Please contact support with your transaction hash if the purchase doesn't appear in your history.",
            { autoClose: 10000 }
          );
          
          // Still update the UI to refresh
          setupdateCount(updateCount+1);
          
          console.error("Backend API error details:", {
            message: apiError.message,
            response: apiError.response?.data,
            status: apiError.response?.status
          });
        }
      }
      
      console.log("Data unit bought successfully");
      setShowPopup(true);
    } catch (error) {
      setBackDropState(false);
      console.error("🚨 Error buying data unit:", error);
      
      // Handle specific smart contract errors
      if (error.message.includes("insufficient funds") || error.message.includes("Insufficient ETH")) {
        toast.error("Insufficient Sepolia ETH balance for purchase and gas fees");
      } else if (error.message.includes("Data unit does not exist")) {
        toast.error("This data unit no longer exists");
      } else if (error.message.includes("You cannot buy this data unit because your are the provider")) {
        toast.error("You cannot buy your own data unit");
      } else if (error.message.includes("Incorrect payment amount")) {
        toast.error("Payment amount is incorrect - check ETH price");
      } else {
        toast.error(error.message || "Failed to buy data unit with Sepolia ETH. Please try again.");
      }
      
      setResultq("Error buying data unit. Please try again.");
      setShowPopup(true);
    }
  }



  // getTDUtokens function removed - using ETH payments only
  const [WalletAddresses, setWalletAddresses] = useState({});
  const [defaultWallet, setDefaultWallet] = useState("");
  useEffect(() => {
    const getWalletAddress = async () => {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });

        // Always use unified endpoint that supports all roles
        const data = await ApiCall.SECURE_API.get("/user/GetWalletAddresses");
        let WalletsIds = data.data.data || [];
        let options = {};
        let connectedWallet = "";

        for (let i = 0; i < WalletsIds.length; i++) {
          const w = WalletsIds[i];
          if (typeof w === 'string' && w.trim()) {
            options[w] = w; // label equals address for clarity
            for (let j = 0; j < accounts.length; j++) {
              if (w.toLowerCase() === accounts[j].toLowerCase()) {
                connectedWallet = w;
              }
            }
          }
        }
        setWalletAddresses(options);
        if (connectedWallet) {
          setDefaultWallet(connectedWallet);
          console.log("✅ Connected wallet is registered:", connectedWallet);
        } else if (accounts.length > 0) {
          console.log("❌ Connected wallet is not registered:", accounts[0]);
          toast.error("Connect Wallet Address registered with this profile");
        }
      } catch (error) {
        console.log("Error getting wallet addresses:", error);
        toast.error("Failed to validate wallet address");
      }
    };
    getWalletAddress();
  }, []);
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // const handleGoBack = () => {
  //   navigate("/main");
  // };
  const initWeb3 = async () => {
    if (window.ethereum) {
      // Modern dapp browsers
      const web3Instance = new Web3(window.ethereum);
      try {
        // Request user approval to access their accounts
        await window.ethereum.enable();
        setWeb3(web3Instance);
        setisconnected(true);
        localStorage.setItem("web3Instance", JSON.stringify(web3Instance)); // Save web3 instance to local storage
      } catch (error) {
        // if (error?.response?.data?.message) {
        //            toast.error(error.response.data.message);
        //          } else {
        //            toast.error(error.message);
        //          }
        console.error(error);
      }
    } else if (window.web3) {
      // Legacy dapp browsers
      const web3Instance = new Web3(window.web3.currentProvider);
      setWeb3(web3Instance);
    } else {
      // Non-dapp browsers
      console.log("Please install MetaMask!");
    }
  };
  useEffect(() => {
    initWeb3();
  }, []);
  useEffect(() => {
    const initContracts = async () => {
      try {
        // FX main contract at contractAddress
        const fx = new web3.eth.Contract(contractABI, contractAddress);
        setFxContract(fx);
        // TDU contract initialization removed - using ETH payments only
      } catch (error) {
        console.log("Error initializing contracts:", error);
      }
    };

    if (web3) {
      initContracts();
    }
  }, [web3, contractAddress]);


 const onSubmitBuyDataUnit=(row) => {
  const rowId = row._id || row.id;
  // Check if level is already in state, or use the level from the row (since each row represents a specific level)
  let selectedLevel = selectedLevels[rowId];
  
  // If row already has a selectedLevel (from BUY button click), use that
  if (row.selectedLevel && row.levelIndex !== undefined) {
    selectedLevel = {
      levelIndex: row.levelIndex,
      levelData: row.selectedLevel,
      rowId: rowId
    };
    // Save it to state for future reference
    setSelectedLevels(prev => ({
      ...prev,
      [rowId]: selectedLevel
    }));
  }

if(row.isAlreadyPurchased){
  Swal.fire({
    title: "Are you sure?",
    text: "You have already purchased this data unit.Do you want to purchase it again?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, Buy it again"
  }).then((result) => {
    if (result.isConfirmed) {
      // Check if this is a multi-level fund
      if (row.pricingLevels && row.pricingLevels.length > 1) {
        // Check if a level is already selected (either from state or from the row itself)
        if (selectedLevel && selectedLevel.levelData) {
          const updatedRow = {
            ...row,
            selectedLevel: selectedLevel.levelData
          };
          
          Swal.fire({
            title: "Select Wallet Address",
            input: "select",
            inputOptions: WalletAddresses,
            inputPlaceholder: "Select Wallet Address",
            inputValue: defaultWallet,
            showCancelButton: true,
            inputValidator: (value, index) => {
              buyDataUnit(updatedRow, value);
            },
          });
        } else {
          showLevelSelectionDialog(row, true);
        }
      } else {
    Swal.fire({
      title: "Select Wallet Address",
      input: "select",
      inputOptions: WalletAddresses,
      inputPlaceholder: "Select Wallet Address",
      inputValue: defaultWallet,
      showCancelButton: true,
      inputValidator: (value, index) => {
        buyDataUnit(row, value);
      },
    });
      }
  }
  })
}else{
  // Check if this is a multi-level fund
  if (row.pricingLevels && row.pricingLevels.length > 1) {
    // Check if a level is already selected (either from state or from the row itself)
    if (selectedLevel && selectedLevel.levelData) {
      const updatedRow = {
        ...row,
        selectedLevel: selectedLevel.levelData
      };
      
      Swal.fire({
        title: "Select Wallet Address",
        input: "select",
        inputOptions: WalletAddresses,
        inputPlaceholder: "Select Wallet Address",
        inputValue: defaultWallet,
        showCancelButton: true,
        inputValidator: (value, index) => {
          if(updatedRow.providerWalletAddress.toLowerCase()==value.toLowerCase()){
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You cannot purchase this data unit with this account because this data unit was created with the same account',
            });      
          }else{
            buyDataUnit(updatedRow, value);
          }
        },
      });
    } else {
      showLevelSelectionDialog(row, false);
    }
  } else {
  Swal.fire({
    title: "Select Wallet Address",
    input: "select",
    inputOptions: WalletAddresses,
    inputPlaceholder: "Select Wallet Address",
    inputValue: defaultWallet,
    showCancelButton: true,
    inputValidator: (value, index) => {
      if(row.providerWalletAddress.toLowerCase()==value.toLowerCase()){
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You cannot purchase this data unit with this account because this data unit was created with the same account',
        });      
      }else{
        buyDataUnit(row, value);
        }
      },
    });
  }
}
}

// New function to show level selection dialog
const showLevelSelectionDialog = (row, isRepurchase) => {
  // Check for pricing levels in different possible field names
  const pricingLevels = row?.pricingLevels || row?.pricing_levels || row?.levels || [];
  
  if (!pricingLevels || pricingLevels.length === 0) {
    toast.error("No pricing levels available for this fund");
    return;
  }
  
  const levelOptions = {};
  pricingLevels.forEach((level, index) => {
    levelOptions[`level_${index}`] = `Level ${level.levelName || level.level_name || (index + 1)} - Max: $${level.maxAmountUSD || level.max_amount_usd || 0} - Ticket: $${level.ticketUSD || level.ticket_usd || 0} - Yield: ${level.annualYieldPercent || level.annual_yield_percent || 0}%`;
  });

  Swal.fire({
    title: "Select Pricing Level",
    text: "Choose which pricing level you want to purchase:",
    input: "select",
    inputOptions: levelOptions,
    inputPlaceholder: "Select a pricing level",
    showCancelButton: true,
    inputValidator: (value) => {
      if (!value) {
        return "Please select a pricing level";
      }
      
      // Extract level index from selected value
      const levelIndex = parseInt(value.split('_')[1]);
      const selectedLevelData = row.pricingLevels[levelIndex];
      
      // Save the selected level to state so it's remembered for next time
      const rowId = row._id || row.id;
      setSelectedLevels(prev => ({
        ...prev,
        [rowId]: {
          levelIndex: levelIndex,
          levelData: selectedLevelData,
          rowId: rowId
        }
      }));
      
      // Update row with selected level pricing - calculate ETH from USD
      // Try to get quantity from state (check both base key and level-specific key)
      const levelSpecificKey = `${rowId}_${levelIndex}`;
      const quantity = ticketQuantities[levelSpecificKey] || ticketQuantities[rowId] || 1;
      
      const updatedRow = {
        ...row,
        selectedLevel: selectedLevelData,
        ticketsQuantity: quantity, // Pass quantity directly in the row
        quantity: quantity, // Also store as quantity for backward compatibility
        levelIndex: levelIndex // Store levelIndex for debugging
      };
      
      // Now show wallet selection
      Swal.fire({
        title: "Select Wallet Address",
        input: "select",
        inputOptions: WalletAddresses,
        inputPlaceholder: "Select Wallet Address",
        inputValue: defaultWallet,
        showCancelButton: true,
        inputValidator: (walletValue) => {
          if (updatedRow.providerWalletAddress.toLowerCase() == walletValue.toLowerCase()) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'You cannot purchase this data unit with this account because this data unit was created with the same account',
            });
          } else {
            buyDataUnit(updatedRow, walletValue);
          }
        },
      });
    },
  });
}
const [ethPrice, setEthPrice] = useState(null);
useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await ApiCall.Api.get('/thirdPartyApi/getCryptoData');
      const ethereumData = response.data.data['1027'];
      // Extract the USD price from the API response
      const usdPrice = ethereumData.quote.USD.price;
      // Update the state with the USD price

      
      setEthPrice(usdPrice);
      // const exchangeRate = ethereumData.quote.USD.price;
      // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
      // setUsdAmount(convertedUsdAmount.toFixed(2));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  fetchData();
}, []);
const getPriceInUsd=(value)=>{
const exchangeRate = ethPrice;
        const convertedUsdAmount = parseFloat(value) * exchangeRate;
       return convertedUsdAmount.toFixed(6)
}
const [anchorEl, setAnchorEl] = useState(null);
const handleClose = () => {
  setAnchorEl(null);
};
const handleClick = (event) => {
  setAnchorEl(event.currentTarget);
}
const DropDown=(row)=>{

  return(
    <>
    <span  onClick={(e) => {
                  handleClick(e);
                }} style={{color:"green",cursor:"pointer"}} >{row.available?<span>Available</span>:<span style={{color:"red"}}>Unavailable</span>}</span>
     
      <Menu id="simple-menu" anchorEl={anchorEl} open={anchorEl} onClose={handleClose}>
                <MenuItem
                  onClick={() => {
                    // setOpen(true)
                    // Navigate(`/admin-panel/Booking/Room_Detail/${"Edit"}/${deleteState}`)
                    updateStatusFunction(true)
                    handleClose();
                  }}
                >
                  <span style={{ display: 'flex', width: '100%', padding: 5 }}>
                    {/* <EditIcon onClick={() => { }} style={{ marginRight: 5 }} /> */}
                    <span>Available</span>
                  </span>
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    // setOpen(true)
                    // Navigate(`/admin-panel/Booking/Room_Detail/${"Edit"}/${deleteState}`)
                    updateStatusFunction(false)

                    handleClose();
                  }}
                >
                  <span style={{ display: 'flex', width: '100%', padding: 5 }}>
                    {/* <EditIcon onClick={() => { }} style={{ marginRight: 5 }} /> */}
                    <span>Unavailable</span>
                  </span>
                </MenuItem>
               
              </Menu>
    </>
  )
}
const updateStatusFunction = async (status) => {
  try {
    const response = await ApiCall.SECURE_API.post('/admin/updateDataunitAvailability',{
      "dataunitId": UnitStatus,
      "available": status
  
  });
  if(response.data.success==true){
toast.success(response.data.message);
setupdateCount(updateCount+1)

  }
    // const exchangeRate = ethereumData.quote.USD.price;
    // const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
    // setUsdAmount(convertedUsdAmount.toFixed(2));
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
const handleRowClick=(row,id,index) => {
  setUnitStatus(row._id)

}
function formatEtherFromWei(weiValue, decimalPlaces) {
  // Check if web3 is available
  if (!web3) {
    console.warn("Web3 not initialized, cannot format price");
    return "Connect Wallet Address registered with this profile";
  }
  
  try {
    // Convert wei to ether using Web3.js utility function
    const etherValue = web3.utils.fromWei(weiValue, "ether");

    // Limit the ether value to a specified number of decimal places
    const formattedEther = parseFloat(etherValue).toFixed(decimalPlaces);

    // Return the formatted ether value with "ETH" appended
    return formattedEther + " ETH";
  } catch (error) {
    console.error("Error formatting price:", error);
    return "Error";
  }
}

// Helper function to flatten rows - each pricing level becomes a separate row
const flattenRowsWithLevels = (rows) => {
  const flattened = [];
  rows.forEach((row) => {
    const pricingLevels = row?.pricingLevels || row?.pricing_levels || row?.levels || [];
    const pricingType = row?.pricingType || row?.pricing_type;
    
    // Only create separate rows if it's a multi-level fund with pricing levels
    if (pricingType === 'levels' && pricingLevels && pricingLevels.length > 0) {
      // Multi-level fund: create a row for each level
      pricingLevels.forEach((level, idx) => {
        flattened.push({
          ...row,
          level: level,
          levelIndex: idx,
          isLevelRow: true
        });
      });
    } else {
      // Single level or fixed pricing: create one row without level data
      flattened.push({
        ...row,
        level: null,
        levelIndex: -1,
        isLevelRow: false
      });
    }
  });
  return flattened;
};

  // Flatten rows for rendering - each pricing level becomes a separate row
  const flattenedRows = rows && rows.length > 0 ? flattenRowsWithLevels(rows) : [];
  
  return (
    <>

      <TableContainer style={{ borderRadius: 9 }} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead style={{ backgroundColor: "Black" }}>
          <TableRow>
            <TableCell align="center" style={{ color: "white" }}>
              Fund Creation Date
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
              Institution
            </TableCell>
            {role !== "Fund Subscriber" && (
              <>
                <TableCell align="center" style={{ color: "white" }}>
                  Code
                </TableCell>
                <TableCell align="center" style={{ color: "white" }}>
                  Instrument
                </TableCell>
              </>
            )}
            <TableCell align="center" style={{ color: "white" }}>
              Fund
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
              Level
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Coin Price
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Ticket Size (Min Inv.)
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Investment
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Yield
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Tickets
            </TableCell>
            <TableCell align="right" style={{ color: "white" }}>
              Price
            </TableCell>
            <TableCell align="center" style={{ color: "white" }}>
              Execution
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows || rows.length === 0 ? (
            <TableRow>
              <TableCell colSpan={role !== "Fund Subscriber" ? 13 : 11} align="center" style={{ padding: 40 }}>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 18, color: "#666", marginBottom: 10 }}>
                    {!rows ? "Loading fund assets..." : "No fund assets available"}
                  </div>
                  {!rows && (
                    <div style={{ fontSize: 14, color: "#999" }}>
                      Please wait while we fetch the latest data...
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
          ) : (
            flattenedRows.map((row, index) => {
              // Get level data for this row
              const level = row.level;
              const levelIndex = row.levelIndex;
              const pricingLevels = row?.pricingLevels || row?.pricing_levels || row?.levels || [];
              
              // Calculate values based on level or base row
              let ticketUSD = 0;
              let ticketETH = 0;
              
              if (level) {
                ticketUSD = level?.ticketUSD || level?.ticket_usd || 0;
                ticketETH = level?.ticketETH || level?.ticket_eth || 0;
              } else if (row.price && web3 && ethPrice) {
                try {
                  ticketETH = parseFloat(web3.utils.fromWei(row.price, 'ether')) || 0;
                  ticketUSD = ticketETH * ethPrice;
                } catch (error) {
                  console.error('Error calculating ticket price:', error);
                  ticketUSD = 0;
                  ticketETH = 0;
                }
              }
              const annualYield = level?.annualYieldPercent || level?.annual_yield_percent || 0;
              
              // Coin Price - try to get from level or calculate (assume coin price per TDUX)
              // Based on image: Investment TDUX = Ticket Size USD / Coin Price USD
              // So if we have Investment TDUX and Ticket Size USD, we can calculate coin price
              // For now, we'll use a default or try to derive it
              // Note: Coin price might need to come from the fund data or tokenize screen
              const coinPriceUSD = level?.coinPriceUSD || level?.coin_price_usd || 
                                   row?.coinPriceUSD || row?.coin_price_usd || 
                                   0.10; // Default fallback - should be replaced with actual data
              
              // Investment in TDUX = Ticket Size USD / Coin Price USD
              const investmentTDUX = ticketUSD && coinPriceUSD ? Math.floor(ticketUSD / coinPriceUSD) : 0;
              
              // Yield per year in TDUX = (Investment TDUX * Yield %) / 100
              const yieldPerYearTDUX = investmentTDUX && annualYield ? (investmentTDUX * annualYield) / 100 : 0;
              
              // Format yield per year (show "240k" for large numbers)
              const formatYieldTDUX = (yieldValue) => {
                if (yieldValue >= 1000000) return `${(yieldValue / 1000000).toFixed(1)}M`;
                if (yieldValue >= 1000) return `${(yieldValue / 1000).toFixed(0)}k`;
                return Math.floor(yieldValue).toString();
              };
              
              // Calculate % over all previous levels based on Investment TDUX
              const getInvestmentOverPrevious = () => {
                if (levelIndex === 0 || !pricingLevels || pricingLevels.length === 0) return '';
                const comparisons = [];
                
                // Get current level's investment
                const currentInvestment = investmentTDUX;
                
                for (let i = 0; i < levelIndex; i++) {
                  const prevLevel = pricingLevels[i];
                  const prevTicketUSD = prevLevel?.ticketUSD || prevLevel?.ticket_usd || 0;
                  
                  // Get previous level's coin price (each level might have its own, or use fund-level coin price)
                  const prevCoinPrice = prevLevel?.coinPriceUSD || prevLevel?.coin_price_usd || 
                                       row?.coinPriceUSD || row?.coin_price_usd || 
                                       coinPriceUSD; // Fallback to current level's coin price
                  
                  // Calculate previous level's investment in TDUX using its own coin price
                  const prevInvestment = prevTicketUSD && prevCoinPrice ? Math.floor(prevTicketUSD / prevCoinPrice) : 0;
                  
                  if (prevInvestment > 0 && currentInvestment > 0) {
                    // Calculate percentage: ((Current Investment - Previous Investment) / Previous Investment) * 100
                    // Formula: ((Current TDUX - Previous TDUX) / Previous TDUX) * 100
                    // Cap at 100% maximum
                    let percentOver = Math.round(((currentInvestment - prevInvestment) / prevInvestment) * 100);
                    percentOver = Math.min(percentOver, 100); // Cap at 100% maximum
                    comparisons.push(`${percentOver}% over Level ${i + 1}`);
                  }
                }
                return comparisons.join(' / ');
              };
              
              // Get unique key for ticket quantity tracking (row._id + levelIndex)
              const rowKey = `${row._id}_${levelIndex}`;
              const qty = ticketQuantities[rowKey] ?? 0;
              
              // Calculate price based on level and quantity
              // Price in USD is fixed, ETH is floating (calculated from USD using current ETH price)
              let priceToUse = row.price || level?.price;
              
              let priceEth = 0;
              let totalEth = 0;
              let totalUsd = 0;
              
              // USD is fixed: ticketUSD * quantity
              totalUsd = ticketUSD * qty;
              
              // ETH is floating: calculate from USD using current ETH price
              if (ethPrice && totalUsd > 0) {
                totalEth = totalUsd / ethPrice;
              } else if (priceToUse && web3) {
                try {
                  priceEth = parseFloat(web3.utils.fromWei(priceToUse, "ether")) || 0;
                  totalEth = priceEth * qty;
                } catch (error) {
                  console.error('Error calculating total price:', error);
                  totalEth = 0;
                }
              }
              
              // Fund name - remove "- Multi-Level Fund" and make clickable
              let fundName = row?.name || 'N/A';
              fundName = fundName.replace(/\s*-\s*Multi-Level Fund\s*/i, '');
              
              // Get contract address for explorer link
              const contractAddr = row?.contractAddress || row?.contract_address || 
                                   row?.tokenizedFundAddress || contractAddress;
              const explorerLink = contractAddr 
                ? `https://sepolia.etherscan.io/address/${contractAddr}`
                : null;
              
              return (
            <TableRow
              key={`${row._id}_${levelIndex}`}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              onClick={()=>{
                handleRowClick(row, row._id, index)
              }}
            >
              <TableCell align="center">
                <span style={{ fontWeight: 600 }}>
                  {convertDateFormat(row.createdAt)}
                </span>
              </TableCell>
              <TableCell align="center">
                {row?.providerData?.institutionName}
              </TableCell>
              {role !== "Fund Subscriber" && (
                <>
                  <TableCell align="center">
                    {row?.providerData?.institutionCode}
                  </TableCell>
                  <TableCell align="center">{row.instrument}</TableCell>
                </>
              )}
              <TableCell align="center">
                {explorerLink ? (
                  <a
                    href={explorerLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: '#1976d2',
                      textDecoration: 'none',
                      fontWeight: 500,
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {fundName}
                  </a>
                ) : (
                  <span>{fundName}</span>
                )}
              </TableCell>
              <TableCell align="center">
                {level ? `Level ${level.levelName || level.level_name || (levelIndex + 1)}` : ''}
              </TableCell>
              <TableCell align="right">
                {level ? `${isNaN(coinPriceUSD) ? '0.00' : Number(coinPriceUSD).toFixed(2)} USD` : ''}
              </TableCell>
              <TableCell align="right">
                {level ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <span style={{ fontWeight: 600 }}>
                      {isNaN(ticketETH) ? '0.00000' : Number(ticketETH).toFixed(5)} ETH
                    </span>
                    <span style={{ color: 'gray' }}>
                      {isNaN(ticketUSD) ? '0.00' : Number(ticketUSD).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD
                    </span>
                  </div>
                ) : (
                  <span style={{ textAlign: 'right' }}>1</span>
                )}
              </TableCell>
              <TableCell align="right">
                {level ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <span style={{ fontWeight: 600 }}>
                      {isNaN(investmentTDUX) ? '0' : Number(investmentTDUX).toLocaleString()} TDUX
                    </span>
                  </div>
                ) : (
                  <span>---</span>
                )}
              </TableCell>
              <TableCell align="right">
                {level ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <span style={{ fontWeight: 600 }}>
                      {isNaN(annualYield) ? '0' : Number(annualYield)}%
                    </span>
                    <span style={{ color: 'gray' }}>
                      {formatYieldTDUX(yieldPerYearTDUX)} TDUX /year
                    </span>
                  </div>
                ) : (
                  <span></span>
                )}
              </TableCell>
              <TableCell align="right">
                <input
                  type="number"
                  min={0}
                  value={qty}
                  onChange={(e) => {
                    const value = parseInt(e.target.value || '0');
                    setTicketQuantities((prev) => ({ ...prev, [rowKey]: isNaN(value) ? 0 : Math.max(0, value) }));
                  }}
                  onClick={(e) => e.stopPropagation()}
                  style={{ width: 70, textAlign: 'right', padding: '4px' }}
                />
              </TableCell>
              <TableCell align="right">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <span style={{ fontWeight: 600 }}>
                    {isNaN(totalEth) ? '0.00000' : Number(totalEth).toFixed(5)} ETH
                  </span>
                  <span style={{ color: 'gray' }}>
                    {isNaN(totalUsd) ? '0.00' : Number(totalUsd).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD
                  </span>
                </div>
              </TableCell>
              <TableCell align="center">
                <Button
                  disabled={!row.available || qty <= 0}
                  style={{
                    backgroundColor: (() => {
                      if (!row.available) return "red";
                      if (row.isAlreadyPurchased) return "gray";
                      if (qty <= 0) return "#cccccc";
                      return "#1976d2";
                    })(),
                    color: "white"
                  }}
                  onClick={async (e) => {
                    e.stopPropagation();
                    // Update row with selected level and quantity before buying
                    const updatedRow = {
                      ...row,
                      price: priceToUse,
        selectedLevel: level,
        ticketsQuantity: qty, // Pass quantity directly in the row
        quantity: qty // Also store as quantity for backward compatibility
                    };
                    // Set the selected level for this fund row
                    setSelectedLevels(prev => ({
                      ...prev,
                      [row._id]: {
                        levelIndex: levelIndex,
                        levelData: level,
                        rowId: row._id
                      }
                    }));
                    // Update ticket quantity for the base row (not level-specific)
                    setTicketQuantities(prev => ({
                      ...prev,
                      [row._id]: qty
                    }));
                    await onSubmitBuyDataUnit(updatedRow);
                  }}
                  variant="contained"
                >
                  {(() => {
                    if (!row.available) return "Unavailable";
                    if (row.isAlreadyPurchased) return "Paid";
                    if (qty <= 0) return "BUY";
                    return "BUY";
                  })()}
                </Button>
              </TableCell>
            </TableRow>
            );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
    </>
  );
}
